'use client';

import { useEffect } from 'react';

import { HotkeysProvider, HotkeysScopeProvider } from '@/shared/components/hotkeys';
import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { useIdleIntercom } from '@/shared/hooks/use-intercom-widget';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

import { MARKETING_PAGE } from '../../utils/marketing-analytics';
import { FAQStructuredData } from '../common/faq-structured-data';
import { AiAgentSection } from '../views/ai-agent-section';
import { CTASection } from '../views/cta-section';
import { FAQSection } from '../views/faq-section';
import { FeaturesSection } from '../views/features-section';
import { FooterSection } from '../views/footer-section';
import { HeaderSection } from '../views/header-section';
import { HeroSection } from '../views/hero-section';
import { PricingSection } from '../views/pricing-section';
import { ProductDemoVideo } from '../views/product-demo-video';
import { SocialProofSection } from '../views/social-proof-section';
import { TrustedStartups } from '../views/trusted-startups';

function LandingPage() {
	useIdleIntercom();

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_LANDING_PAGE, {
			feature: MIXPANEL_APP_FEATURES.LANDING_PAGE,
		});
	}, []);

	return (
		<HotkeysProvider>
			<HotkeysScopeProvider scope="landing-page">
				<FAQStructuredData />
				<div className="flex min-h-screen w-full flex-col bg-[#F8F8F8] md:[&_.landing-width]:max-w-[960px]">
					<HeaderSection page={MARKETING_PAGE.LANDING} />

					{/* Main Content */}
					<div className="flex w-full flex-1 flex-col items-center justify-start overflow-x-clip pt-8 md:pt-16">
						<HeroSection />
						<ProductDemoVideo />
						<TrustedStartups compact hideDivider />
						<SocialProofSection />
						<FeaturesSection />
						<AiAgentSection />
						<PricingSection />
						<FAQSection headingClassName="text-balance !text-[32px] tracking-tight md:!text-[48px]" />
						<CTASection
							page={MARKETING_PAGE.LANDING}
							title="Ready to try?"
							headingClassName="text-balance !text-[32px] tracking-tight md:!text-[48px]"
						/>
					</div>

					<FooterSection />
				</div>
			</HotkeysScopeProvider>
		</HotkeysProvider>
	);
}

export default LandingPage;
